<div class="book-demo-page-wrapper">
  <!-- Minimal Top Header Bar -->
  <header class="demo-header">
    <div class="header-container">
      <a class="brand-logo-link" (click)="goBackHome()">
        <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="brand-logo-img" />
      </a>
      <button class="btn-back-home" (click)="goBackHome()">
        <span>← Back to Home</span>
      </button>
    </div>
  </header>

  <!-- Main Card Stage -->
  <main class="demo-main-container">
    <div class="demo-card">
      <h1 class="demo-title">Book A Demo</h1>

      <form [formGroup]="demoForm" (ngSubmit)="onSubmit()" class="demo-form-grid">
        <!-- Row 1: Full Name & Phone Number -->
        <div class="form-row two-col">
          <div class="input-field-group">
            <div class="input-wrapper">
              <input type="text" formControlName="fullName" placeholder="Full Name" class="form-control-custom"
                [ngClass]="{ 'is-invalid': demoForm.get('fullName')?.touched && demoForm.get('fullName')?.invalid }" />
              <span class="field-icon icon-user">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </span>
            </div>
            <div *ngIf="demoForm.get('fullName')?.touched && demoForm.get('fullName')?.invalid"
              class="invalid-feedback">
              Full Name is required.
            </div>
          </div>

          <div class="input-field-group">
            <div class="input-wrapper">
              <input type="tel" formControlName="phoneNumber" placeholder="Phone Number" class="form-control-custom"
                [ngClass]="{ 'is-invalid': demoForm.get('phoneNumber')?.touched && demoForm.get('phoneNumber')?.invalid }" />
              <span class="field-icon icon-phone">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                  </path>
                </svg>
              </span>
            </div>
            <div *ngIf="demoForm.get('phoneNumber')?.touched && demoForm.get('phoneNumber')?.invalid"
              class="invalid-feedback">
              Valid Phone Number is required (+91 or 10 digits).
            </div>
          </div>
        </div>

        <!-- Row 2: Work Email (Full Width) -->
        <div class="form-row single-col">
          <div class="input-field-group">
            <div class="input-wrapper">
              <input type="email" formControlName="workEmail" placeholder="Work Email" class="form-control-custom"
                [ngClass]="{ 'is-invalid': demoForm.get('workEmail')?.touched && demoForm.get('workEmail')?.invalid }" />
              <span class="field-icon icon-email">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </span>
            </div>
            <div *ngIf="demoForm.get('workEmail')?.touched && demoForm.get('workEmail')?.invalid"
              class="invalid-feedback">
              Valid Work Email is required.
            </div>
          </div>
        </div>

        <!-- Row 3: Company & Select Role -->
        <div class="form-row two-col">
          <div class="input-field-group">
            <div class="input-wrapper">
              <input type="text" formControlName="company" placeholder="Company" class="form-control-custom"
                [ngClass]="{ 'is-invalid': demoForm.get('company')?.touched && demoForm.get('company')?.invalid }" />
              <span class="field-icon icon-company">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                  <path d="M6 12H4a2 2 0 0 0-2 2v8h4"></path>
                  <path d="M18 9h2a2 2 0 0 1 2 2v11h-4"></path>
                  <path d="M10 6h4"></path>
                  <path d="M10 10h4"></path>
                  <path d="M10 14h4"></path>
                  <path d="M10 18h4"></path>
                </svg>
              </span>
            </div>
            <div *ngIf="demoForm.get('company')?.touched && demoForm.get('company')?.invalid" class="invalid-feedback">
              Company Name is required.
            </div>
          </div>

          <div class="input-field-group">
            <div class="input-wrapper">
              <select formControlName="role" class="form-control-custom select-role"
                [ngClass]="{ 'is-invalid': demoForm.get('role')?.touched && demoForm.get('role')?.invalid }">
                <option value="" disabled selected>Select Role</option>
                <option *ngFor="let r of roles" [value]="r">{{ r }}</option>
              </select>
            </div>
            <div *ngIf="demoForm.get('role')?.touched && demoForm.get('role')?.invalid" class="invalid-feedback">
              Role selection is required.
            </div>
          </div>
        </div>

        <!-- Row 4: Preferred Date Time Picker -->
        <div class="form-row single-col">
          <div class="input-field-group">
            <div class="input-wrapper">
              <input type="datetime-local" formControlName="dateTime" placeholder="mm/dd/yyyy --:-- --"
                class="form-control-custom date-time-control"
                [ngClass]="{ 'is-invalid': demoForm.get('dateTime')?.touched && demoForm.get('dateTime')?.invalid }" />
            </div>
            <div *ngIf="demoForm.get('dateTime')?.touched && demoForm.get('dateTime')?.invalid"
              class="invalid-feedback">
              Please select a preferred date and time for the demo.
            </div>
          </div>
        </div>

        <!-- Status Message Banner -->
        <div *ngIf="statusMessage" class="status-alert" [ngClass]="statusType">
          {{ statusMessage }}
        </div>

        <!-- Submit Button Row -->
        <div class="form-submit-row">
          <button type="submit" class="btn-book-demo-submit" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Book Demo</span>
            <span *ngIf="isSubmitting">Submitting...</span>
          </button>
        </div>
      </form>
    </div>
  </main>
</div>